import WholeMilkProduct from 'models/WholeMilkProduct'

export const milkTypeOptions = [
  {
    value: '',
    label: 'Milk Type',
    isDisabled: true,
  },
  {
    value: 'Whole',
    label: 'Whole',
    subCategory: '001',
  },
  {
    value: 'Whole Lactose Free',
    label: 'Whole Lactose Free',
    subCategory: '003',
  },
  { value: 'Whole Evaporated', label: 'Whole Evaporated', subCategory: '011' },
]

export const containerSizeOptions = [
  {
    value: '',
    label: 'Size',
    isDisabled: true,
  },
  {
    value: 'Half Gallon',
    label: 'Half Gallon',
  },
  { value: 'One Gallon', label: 'One Gallon' },
  { value: '12 oz Can', label: '12 oz Can' },
]

export const containerSizeOptionsDefault = [
  {
    value: '',
    label: 'Size',
    isDisabled: true,
  },
]

export const wholeContainerSizeOptions = [
  {
    value: '',
    label: 'Size',
    isDisabled: true,
  },
  {
    value: 'Half Gallon',
    label: 'Half Gallon',
  },
  { value: 'One Gallon', label: 'One Gallon' },
]

export const lactoseContainerSizeOptions = [
  {
    value: '',
    label: 'Size',
    isDisabled: true,
  },
  {
    value: 'Half Gallon',
    label: 'Half Gallon',
  },
]

export const evaporatedContainerSizeOptions = [
  {
    value: '',
    label: 'Size',
    isDisabled: true,
  },
  { value: '12 oz Can', label: '12 oz Can' },
]

export const packagingInitialState = {
  category: WholeMilkProduct.category,
  subCategory: WholeMilkProduct.subCategory,
  WholeMilkType: {
    value: milkTypeOptions[0].value,
    label: milkTypeOptions[0].label,
  },
  WholeMilkSize: {
    value: containerSizeOptions[0].value,
    label: containerSizeOptions[0].label,
  },
}
